import {
  VERIFF_SESSION_REQUEST,
  VERIFF_SESSION_SUCCESS,
  VERIFF_SESSION_FAIL,
  VERIFF_STATUS_UPDATE,
  VERIFF_RESET,
} from "../actions/veriffActions";

const initialState = {
  loading: false,
  sessionId: null,
  verificationUrl: null,
  status: "not_started",
  veriffData: null,
  error: null,
  needsVerification: true,
};

const veriffReducer = (state = initialState, action) => {
  switch (action.type) {
    case VERIFF_SESSION_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case VERIFF_SESSION_SUCCESS:
      return {
        ...state,
        loading: false,
        sessionId: action.payload.sessionId,
        verificationUrl: action.payload.verificationUrl,
        error: null,
      };

    case VERIFF_SESSION_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case VERIFF_STATUS_UPDATE:
      return {
        ...state,
        status: action.payload.status,
        veriffData: action.payload.veriffData,
        needsVerification: action.payload.status !== "approved",
      };

    case VERIFF_RESET:
      return initialState;

    default:
      return state;
  }
};

export default veriffReducer;
